import { render, staticRenderFns } from "./WelfareMonitoring.vue?vue&type=template&id=1bbaced8&scoped=true&"
import script from "./WelfareMonitoring.vue?vue&type=script&lang=js&"
export * from "./WelfareMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./WelfareMonitoring.vue?vue&type=style&index=0&id=1bbaced8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbaced8",
  null
  
)

export default component.exports